const TYPE_MAP = {
  douyin: '抖音',
  '抖音': '抖音',
  meituan: '美团',
  '美团': '美团',
}

export function normalizeYanQuanTicketType(item = {}, fallbackType = '') {
  const explicitType = TYPE_MAP[item.type]
  if (explicitType) return explicitType
  if (item.verifyId || item.douyinConsume) return '抖音'
  return TYPE_MAP[fallbackType] || '美团'
}

export function getYanQuanTicketKey(item = {}, fallbackType = '') {
  if (item.verifyId) return `verifyId:${item.verifyId}`
  if (!item.receiptCode) return ''
  const type = normalizeYanQuanTicketType(item, fallbackType)
  return `receiptCode:${type}:${item.receiptCode}`
}

export function appendUniqueYanQuanTickets(existing = [], incoming = [], fallbackType = '') {
  const items = Array.isArray(existing) ? [...existing] : []
  const added = []
  const bindable = []
  const itemByKey = new Map()
  items.forEach(item => {
    const key = getYanQuanTicketKey(item, fallbackType)
    if (key) itemByKey.set(key, item)
  })
  const bindableKeys = new Set()

  ;(Array.isArray(incoming) ? incoming : []).forEach(item => {
    const key = getYanQuanTicketKey(item, fallbackType)
    if (!key) return
    const existingItem = itemByKey.get(key)
    if (existingItem) {
      if (existingItem.isCodeNew !== false && !bindableKeys.has(key)) {
        bindableKeys.add(key)
        bindable.push(existingItem)
      }
      return
    }
    itemByKey.set(key, item)
    items.push(item)
    added.push(item)
    bindableKeys.add(key)
    bindable.push(item)
  })

  return {items, added, bindable}
}

export function buildYanQuanBindTicket(item = {}, fallbackType = '', verifyTime = '') {
  const type = normalizeYanQuanTicketType(item, fallbackType)
  const isDouyin = type === '抖音'
  const skuTitle = item.data && item.data.sku ? item.data.sku.title : item.receiptCode
  const dealTitle = item.dealTitle || item.goodsName || item.receiptCode

  return {
    goodsName: isDouyin ? `抖音-${skuTitle}` : `美团-${dealTitle}`,
    type,
    receiptCode: item.receiptCode,
    operation: 1,
    verifyCount: 1,
    verifyTime,
    verifyId: item.verifyId || '',
  }
}

export function calculateDouyinTicketPayAmount(items = []) {
  return (Array.isArray(items) ? items : []).reduce((total, item) => {
    const amount = item && item.data && item.data.amount ? item.data.amount : {}
    const couponAmount = Number(amount.coupon_pay_amount) || 0
    const platformDiscount = Number(amount.platform_discount_amount) || 0
    return total + (couponAmount + platformDiscount) * 0.01
  }, 0)
}

export function calculateYanQuanSessionPayAmount(
  items = [],
  type = '',
  getMeituanPayAmount,
  getDouyinPayAmount,
  addAmount
) {
  const normalizedType = normalizeYanQuanTicketType({type}, type)
  const platformTickets = (Array.isArray(items) ? items : []).filter(item => {
    return normalizeYanQuanTicketType(item, type) === normalizedType
  })

  if (normalizedType === '抖音') {
    if (typeof getDouyinPayAmount !== 'function') {
      return calculateDouyinTicketPayAmount(platformTickets)
    }
    return platformTickets.reduce((total, item) => {
      const itemAmount = Number(getDouyinPayAmount(item)) || 0
      return typeof addAmount === 'function'
        ? addAmount(total, itemAmount)
        : Math.round((total + itemAmount) * 100) / 100
    }, 0)
  }

  if (typeof getMeituanPayAmount !== 'function') return 0
  return platformTickets.reduce((total, item) => {
    const itemAmount = Number(getMeituanPayAmount(item)) || 0
    return typeof addAmount === 'function'
      ? addAmount(total, itemAmount)
      : Math.round((total + itemAmount) * 100) / 100
  }, 0)
}

export function selectSuccessfulDouyinTickets(selected = [], verifyResults = []) {
  const successMap = new Map()
  ;(Array.isArray(verifyResults) ? verifyResults : []).forEach(item => {
    if (Number(item && item.result) !== 0 || !item.code) return
    successMap.set(item.code, item)
  })

  return (Array.isArray(selected) ? selected : []).reduce((tickets, item) => {
    const result = successMap.get(item && item.encryptedCode)
    if (!result || !result.origin_code || !result.verify_id) return tickets
    tickets.push({
      ...item,
      type: '抖音',
      receiptCode: result.origin_code,
      verifyId: result.verify_id,
      isCodeNew: true,
    })
    return tickets
  }, [])
}
